import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/specifications')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") { 
        
        return Api.put('api/specifications/' + id , payload)       
    } else {
        return Api.post('api/specifications' , payload)       
    }
    
};

const getById =  (payload) => {        
    return Api.get('api/specifications/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/specifications/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById
};